import typeStyleMap from 'lib/graph-vis/typeStyleMap';
import { ReactComponent as SvgImage } from '../../../public/images/svg/option.svg';

export const ProductOptionIcon = (props) => (
  <SvgImage
    height={props.height || 24}
    style={{ fill: typeStyleMap.productOptionNode.color }}
    {...props}
  />
);

export const ProductOptionTagIcon = (props) => {
  <span role="img" aria-label="product-option tag" className="anticon anticon-product-option-tag">
    <SvgImage style={{ margin: '2px 0 -2px 0' }} height={15} fill={'antiquewhite'} {...props} />
  </span>;
};

export default ProductOptionIcon;
